export default __webpack_public_path__ + "static/media/setting-web.26a95900.svg";